import ProjectData from '@/data/ProjectData.ts'

export default [
    new ProjectData("project-1", "Articoding", "img/projects/articoding_logo_bg.png", 
    `
    <div class="paragraph">
    <strong>Articoding</strong> is a serious educational game that aims to encourage the development of Computational Thinking by teaching basic programming concepts using visual programming.
    The player's goal is to guide a laser beam to a target using visual block programming (similar to Scratch).
    <br/>Art by <a target="_blank" href="https://www.arturogcdev.games/#slide01">Arturo García</a>. 
   </div>
   
   <div class="paragraph">
   Main features :
   <ul>
   <li>Educational game designed to teach Computational Thinking and programming</li>
   <li>5 different categories and 37 unique levels</li>
   <li>Level creation mode to design your own levels</li>
   <li>Learn programming concepts using a Scratch-like language</li>
   <li>Game tested with school students</li>
   </ul>
   </div>

   <div class="paragraph">
    Responsabilities:
   <ul>
   <li>Implementation of the level creator</li>
   <li>Integration of the block based programming language</li>
   <li>Integration of the telemetry system and user analytics</li>
   <li>Implementation of the progress manager and save system</li>
   </ul>
    </div>
   
   <div class="paragraph center">
   <img class="pc-screenshot" src="img/projects/articoding_1.PNG" alt="Articoding Screenshot" />
   <img class="pc-screenshot" src="img/projects/articoding_2.PNG" alt="Articoding Screenshot" />
   </div>

   <div class="paragraph center">
       <a href="https://github.com/WeArePawns/Articoding/releases" target="_blank"><img src="img/projects/get-github.png" alt="GitHub badge" /></a>
   </div>
    `, "#000000"),
    new ProjectData("project-2", "Wishborn", "img/projects/wishborn_title.jpg", `
    <div class="paragraph">
        <strong>Wishborn</strong> is a fast paced 2D platformer made in a week using Unity. It was made by 6 developers as part of the JamOn 2021 and placed third at it.
        <br/>Art by <a target="_blank" href="https://www.arturogcdev.games/#slide01">Arturo García</a>.
    </div>
    <div class="paragraph center">
        <iframe class="youtube" src="https://www.youtube.com/embed/Q_gtkaG7B3Y" frameborder="0" allowfullscreen></iframe>
    </div>

    <div class="paragraph">
        Main features :
        <ul>
        <li>Fast paced 2D platformer</li>
        <li>3 unique levels and one final boss</li>
        <li>Made with Unity3D in a week</li>
        <li>Closed narrative with dialouges and cinematics</li>
        </ul>
    </div>

    <div class="paragraph">
    Responsabilities:
   <ul>
   <li>Implementation of player basic gameplay</li>
   <li>Development of the dialogue and cinematics system</li>
   <li>Implemented behaviour of the final boss </li>
   </ul>
   </div>

    <div class="paragraph">
    <div class="notice">
        Windows build available on <a href="https://xryusey.itch.io/wishborn" target="_blank">itch.io</a>.
        Source code is available on <a href="https://github.com/SpicySeed/Wishborn" target="_blank">GitHub</a>.
    </div>
    </div>

    <div class="paragraph center">
    <img class="pc-screenshot" src="img/projects/wishborn_1.png" alt="Wishborn Screenshot" />
    <img class="pc-screenshot" src="img/projects/wishborn_2.png" alt="Wishborn Screenshot" />
    <img class="pc-screenshot" src="img/projects/wishborn_3.png" alt="Wishborn Screenshot" />
    </div>

    `, "#000000", false, true),
    new ProjectData("project-4", "Anyaroth", "img/projects/anyaroth_image_1.png", `
    <div class="paragraph">
    <strong>Anyaroth</strong> is 2D shoot'em up created in C++ by 8 people using SDL.
    <br/>Art by <a target="_blank" href="https://www.arturogcdev.games/#slide01">Arturo García</a>.    </div>
    
    <div class="paragraph center">
    <iframe class="youtube" src="https://www.youtube.com/embed/9K1WXZMa4X4" frameborder="0" allowfullscreen></iframe>
    </div>

    <div class="paragraph">
        Main features :
        <ul>
        <li>3 unique zones with 2 levels and a boss each</li>
        <li>8 different guns</li>
        <li>More than 5 types of enemies</li>
        <li>Interesting narrative and NPCs</li>
        </ul>
    </div>

    <div class="paragraph">
    Responsabilities:
   <ul>
   <li>Integration of Box2D and implementation of 2D platformer physics</li>
   <li>Development of the tile based map creation and loding system</li>
   <li>Implementation of the 3 AIs of the final bosses </li>
   <li>Implementation of the Input management system</li>
   </ul>
   </div>

    <div class="paragraph">
        <div class="notice">
        Windows build available on <a href="https://pablojor.github.io/Anyaroth/" target="_blank">Anyaroth page</a>.
        Source code is available on <a href="https://github.com/pablojor/Anyaroth" target="_blank">Github</a>.
        </div>
    </div>

    <div class="paragraph center">
        <img class="pc-screenshot" src="img/projects/anyaroth_image_1.png" alt="Anyaroth Screenshot" />
        <img class="pc-screenshot" src="img/projects/anyaroth_image_2.png" alt="Anyaroth Screenshot" />
        <img class="pc-screenshot" src="img/projects/anyaroth_logo.png" alt="Anyaroth Screenshot" />
    </div>
    `, "#000000"),
    new ProjectData("project-5", "Gaia Engine", "img/projects/gaia_logo.png", `
    <div class="paragraph">
        <strong>Gaia Engine</strong> is a videogame engine created in C++ with Ogre3D
        <br/>Art by <a target="_blank" href="https://www.arturogcdev.games/#slide01">Arturo García</a>.
   </div>
    
    <div class="paragraph">
        Main features :
        <ul>
        <li>Component based videogame engine</li>
        <li>Integrated Sound, Physics, Rendering and UI systems</li>
        <li>Data driven engine</li>
        <li>2 games made with it</li>
        </ul>
    </div>

    <div class="paragraph">
    Responsabilities:
    <ul>
    <li>Desingned and developed the engine's structure</li>
    <li>Development data driven component creation system</li>
    <li>Integration of Bullet physics and implementation of the physics system</li>
    <li>Deployment of the engine</li>
    </ul>
    </div>


    <div class="paragraph">
        <div class="notice">
        Source code available on <a href="https://github.com/Spicy-Noodles-Studio/Gaia" target="_blank">GitHub</a>.
        </div>
    </div>

    <div class="paragraph center">
    <img class="pc-screenshot" src="img/projects/intro.png" alt="Gaia intro Screenshot" />
        <img class="pc-screenshot" src="img/projects/tools.png" alt="Gaia tools Screenshot" />
    </div>`, "#000000"),
    new ProjectData("project-3", "Ultimate Ghost Punch", "img/projects/ugp_1.png", `
    <div class="paragraph">
        <strong>Ultimate Ghost Punch</strong> is a 3D fighting videogame made with Gaia engine by a team of 8 developers.
        <br/>Art by <a target="_blank" href="https://www.arturogcdev.games/#slide01">Arturo García</a>.    
    </div>
    <div class="paragraph center">
        <iframe class="youtube" src="https://www.youtube.com/embed/6bLSBjcWSAw" frameborder="0" allowfullscreen></iframe>
    </div>

    <div class="paragraph">
        Main features :
        <ul>
        <li>3D fighting game</li>
        <li>3 different arenas</li>
        <li>Enemy AIs to play with</li>
        <li>Up to 4 players</li>
        </ul>
    </div>

    <div class="paragraph">
    Responsabilities:
    <ul>
    <li>Implementation of the player basic gameplay</li>
    <li>Development of the navigation map creation system</li>
    <li>Implementation of the enemy AI navigation and movement</li>
    <li>Integration of the engine and components creation</li>
    </ul>
    </div>

    <div class="paragraph">
        <div class="notice">
        Downloadable version on <a href="https://spicy-noodles-studio.github.io/Ultimate-Ghost-Punch/" target="_blank"> Ultimate Ghost Punch page</a>.
        Source code is available on <a href="https://github.com/Spicy-Noodles-Studio/Ultimate-Ghost-Punch" target="_blank">GitHub</a>.
        </div>
    </div>

    <div class="paragraph center">
        <img class="pc-screenshot" src="img/projects/ugp_1.png" alt="Ultimate Ghost Punch Screenshot" />
        <img class="pc-screenshot" src="img/projects/ugp_2.png" alt="Ultimate Ghost Punch Screenshot" />
        <img class="pc-screenshot" src="img/projects/ugp_3.png" alt="Ultimate Ghost Punch Screenshot" />
    </div>
    `, "#000000")
];